const FALLBACK_LABEL_COLOR = '#1f93ff';

const splitCommaTitle = title =>
  title
    .split(',')
    .map(part => part.trim())
    .filter(Boolean);

export const resolveActiveLabels = (savedTitles = [], accountLabels = []) => {
  const saved = (Array.isArray(savedTitles) ? savedTitles : [])
    .map(title => String(title || '').trim())
    .filter(Boolean);
  const savedSet = new Set(saved);
  const used = new Set();
  const result = [];

  (accountLabels || []).forEach(label => {
    if (savedSet.has(label.title)) {
      result.push(label);
      used.add(label.title);
      return;
    }

    const parts = splitCommaTitle(label.title);
    if (parts.length > 1 && parts.every(part => savedSet.has(part))) {
      result.push(label);
      parts.forEach(part => used.add(part));
    }
  });

  saved.forEach(title => {
    if (used.has(title)) return;

    const catalogLabel = (accountLabels || []).find(
      label => label.title === title
    );
    result.push(
      catalogLabel || {
        id: `saved:${title}`,
        title,
        color: FALLBACK_LABEL_COLOR,
      }
    );
  });

  return result;
};
